// FontAwesome 5 - https://fontawesome.com/
import "@fortawesome/fontawesome-free/css/all.css";
import "lightgallery/src/sass/lightgallery.scss";

import {
    jarallax,
    jarallaxVideo
} from "jarallax";
import "bootstrap";
import Swiper, {Autoplay, EffectFade, Navigation, Pagination} from "swiper";

Swiper.use([Autoplay, EffectFade, Navigation, Pagination]);

import basicNavigation from "./header/header";
import inlineSVG from "./utilities/convert-svg-to-html";
import "lightgallery";
import "lg-thumbnail";
import "lg-video";

import Instafeed from "instafeed.js";


window.Instafeed = Instafeed;


/*import "datatables.net/js/jquery.dataTables.min.js";
import "moment/moment.js";
import "datatables.net-plugins/sorting/datetime-moment.js";
import "datatables.net-bs5/js/dataTables.bootstrap5.min.js";*/

$(function () {

    basicNavigation();


    jarallaxVideo();

    jarallax(document.querySelectorAll(".HomePage .parallax.intro"), {
        videoSrc: "https://www.youtube.com/watch?v=QGAMTlI6XxY",
        videoStartTime: 35,
        videoEndTime: 120,
        speed: 0.5
    });

    inlineSVG(".navbar-logo, .footer-logo, .admin-logo");

    /*home swiper*/
    var swiper = new Swiper(".news-slider", {
        loop: true,
        slidesPerView: 3,
        autoplay: {
            delay: 50000
        },
        navigation: {
            nextEl: '.next-news',
            prevEl: '.prev-news'
        },
        effect: "slide",
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 3,
            },
            991: {
                slidesPerView: 3,
            },
            1199: {
                slidesPerView: 3,
            }
          },
    });

    $(".lightgallery").lightGallery({
        selector: ".lightgallery-item",
        thumbnail: true
    });

    if(screen.width > 800) {
        $(".dropdown").on('mouseenter',
            function() {
                $(this).addClass("show");
                $(this).find(".dropdown-menu").addClass("show");
            }
        );
        $(".dropdown").on('mouseleave',
            function() {
                let dropdown = $(this);
                dropdown.removeClass("show");
                dropdown.find(".dropdown-menu").removeClass("show");
            }
        );

        $('.dropdown a').on("click", function (event) { window.location.href = this.href; });
    }

    // var swiper = new Swiper(".carousel", {
    //     loop: true,
    //     autoplay: {
    //         delay: 50000
    //     },
    //     pagination: {
    //         el: ".swiper-pagination",
    //         clickable: true
    //     },
    //     effect: "slide",
    //     breakpoints: {
    //         768: {
    //             effect: "fade",
    //         }
    //       },
    // });

    /*let swiperInstance;
    initSwiper(swiperInstance);
    window.addEventListener("resize", initSwiper);*/

    var elementSwiper = new Swiper(".image-gallery-carousel", {
        loop: true,
        effect: "fade",
        navigation: {
            nextEl: ".image-swiper-button-next",
            prevEl: ".image-swiper-button-prev",
        },
        /*autoplay: {
            delay: 5000
        }*/
    });

    var sponsorsSwiper = new Swiper(".sponsors-wrapper", {
        loop: true,
        autoplay: {
            delay: 5000
        }
    });

    // Hide Header on on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = 145;

    $(window).scroll(function (event) {
        didScroll = true;
    });

    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = window.scrollY || document.documentElement.scrollTop;

        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta) return;

        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > 400) {
            $("nav").addClass("page-scrolled");
            $("body").addClass("page-scrolled");
        } else {
            $("nav").removeClass("page-scrolled");
            $("body").removeClass("page-scrolled");
        }

        if (st > lastScrollTop && st > navbarHeight) {
            // Scroll Down
            $("#nav").removeClass("nav-down").addClass("nav-up");
        } else {
            // Scroll Up
            if (st + $(window).height() < $(document).height()) {
                $("#nav").removeClass("nav-up").addClass("nav-down");
            }
        }

        lastScrollTop = st;
    }

    function display_ct() {
        var x = new Date();
        var date_offset = x.getTimezoneOffset();

        var monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];

        var weekday = new Array(7);
        weekday[0] = "Sunday";
        weekday[1] = "Monday";
        weekday[2] = "Tuesday";
        weekday[3] = "Wednesday";
        weekday[4] = "Thursday";
        weekday[5] = "Friday";
        weekday[6] = "Saturday";

        var day = weekday[x.getDay()];
        var month = monthNames[x.getMonth()];

        var timezone_date = "NZDT";
        if (date_offset === -720) {
            timezone_date = "NZST";
        }
        var x1 = timezone_date + addZero(x.getHours()) + ":" + addZero(x.getMinutes())
            + " - " + day + " " + x.getDate() + get_nth_suffix(x.getDate())
            + " OF " + month + ", " + x.getFullYear();
        document.getElementById("ct").innerHTML = x1;
        display_c();

    }

    function display_c() {
        var refresh = 59000;
        setTimeout(function () {
            display_ct();
        }, refresh);
    }

    function get_nth_suffix(x) {
        switch (x) {
            case 1:
            case 21:
            case 31:
                return "st";
            case 2:
            case 22:
                return "nd";
            case 3:
            case 23:
                return "rd";
            default:
                return "th";
        }
    }

    function addZero(i) {
        if (i < 10) {
            i = "0" + i;
        }
        return i;
    }


    /*$.fn.dataTable.moment("D MMM YY", "DD MMM YY");
    $("#arrivals-table").DataTable(
        {
            order: [[0, "desc"]],
            responsive: true
        }
    );

    $("#schedule-table").DataTable(
        {
            order: [[0, "asc"]],
            responsive: true
        }
    );*/


    display_ct();


});

/*function initSwiper(swiperInstance) {
    if (swiperInstance) swiperInstance.destroy(true, true); // Destroy existing instance

    const effectType = window.innerWidth >= 768 ? "fade" : "slide";

    if($('.carousel').length > 0){
        swiperInstance = new Swiper(".carousel", {
            loop: true,
            autoplay: {
                delay: 5000
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            effect: effectType
        });
    }


}*/
